import { createSlice } from '@reduxjs/toolkit';

import { Invitation } from 'entities/Invitation';
import { AppError } from 'entities/Errors';

import { getInvitation } from './invitation.action';

interface InvitationState {
  action: 'idle' | 'get' | 'list';
  status: 'idle' | 'loading' | 'failed' | 'succeed';
  error: null | AppError;
  invitation: Invitation | null;
  invitationList: Invitation[];
}

const initialState: InvitationState = {
  action: 'idle',
  invitation: null,
  invitationList: [],
  error: null,
  status: 'idle',
};

export const invitationSlice = createSlice({
  name: 'invitation',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getInvitation.pending, (state) => {
        state.action = 'get';
        state.error = null;
        state.status = 'loading';
      })
      .addCase(getInvitation.fulfilled, (state, action) => {
        state.status = 'succeed';
        state.invitation = action.payload;
      })
      .addCase(getInvitation.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as AppError;
      });
  },
});

export default invitationSlice.reducer;
